module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CatalogHelp":{"expertAdvisory":{"button":"Chci se zeptat","heading":"Odborná poradna.","text":"Naši odborníci jsou zde pro vás, bleskově odpovíme na vaše dotazy."},"faqQuestions":{"heading":"Odpovědi na časté dotazy"},"shoppingAdvisor":{"heading":"Jak vybrat?"}}}}')
  delete Component.options._Ctor
}
